import { activeAnnotationReducer } from './active-annotation';
import { ACTIVE_ANNOTATION_ID } from './active-annotation/constants';
import type { SetActiveAnnotationAction } from './active-annotation/types';
import { auditingStepReducer } from './auditing-step';
import { AUDITING_STEP } from './auditing-step/constants';
import type { setAuditingStepAction } from './auditing-step/types';
import { annotationReducer } from './annotations';
import { ANNOTATIONS } from './annotations/constants';
import type { AnnotationsAction } from './annotations/types';
import type { AuditActions, AuditState } from './reducers.types';
import { INFERED_ANNOTATIONS } from './infered-annotations/constants';
import { inferedAnnotationsReducer } from './infered-annotations';
import type { InferedAnnotationAction } from './infered-annotations/types';
import { maxIdsReducer } from './max-ids';
import type { UpdateMaxIdsAction } from './max-ids/types';
import { MAX_IDS } from './max-ids/constants';
export const rootReducer = (
  { annotations, activeId, auditStep, inferedAnnotations, maxIds }: AuditState,
  action: AuditActions
): AuditState => ({
  annotations: annotationReducer(annotations, action as AnnotationsAction),
  activeId: activeAnnotationReducer(
    activeId,
    action as SetActiveAnnotationAction
  ),
  auditStep: auditingStepReducer(auditStep, action as setAuditingStepAction),
  inferedAnnotations: inferedAnnotationsReducer(
    inferedAnnotations,
    action as InferedAnnotationAction
  ),
  maxIds: maxIdsReducer(maxIds, action as UpdateMaxIdsAction)
});

export const initialRoot: AuditState = {
  annotations: ANNOTATIONS,
  activeId: ACTIVE_ANNOTATION_ID,
  auditStep: AUDITING_STEP,
  inferedAnnotations: INFERED_ANNOTATIONS,
  maxIds: MAX_IDS
};
